// test1970
(1970 && 0);
